import React, { Component } from 'react'
import { Card, Label, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, UncontrolledCollapse, Row, Col } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            nombre: this.props.nombre,
            inicio: new Date(this.props.inicio.toString()).toISOString().substr(0, 10),
            termino: new Date(this.props.termino.toString()).toISOString().substr(0, 10),
            descripcion: this.props.descripcion,
            convocatoria: this.props.convocatoria,
            documentos: this.props.documentos,
            documentoCheck1: false,
            documentoCheck2: false,
            documentoCheck3: false,
            documentoCheck4: false,
            documentoCheck5: false,
            documentoCheck6: false,
            documentoCheck7: false,
            documentoCheck8: false,
            documentTest: '',
            estado: this.props.estado,
            errors: {}
        }
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                /*case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;*/

                default:
                    break;
            }
        })
    }

    guardar() {
        const { id, convocatoria, nombre, inicio, termino, descripcion } = this.state

        let documentos = [];

        if (this.state.documentoCheck1) {
            documentos.push("solicitud")
        }
        if (this.state.documentoCheck2) {
            documentos.push("acta_nacimiento")
        }
        if (this.state.documentoCheck3) {
            documentos.push("acta_curp")
        }
        if (this.state.documentoCheck4) {
            documentos.push("documento_institucional")
        }
        if (this.state.documentoCheck5) {
            documentos.push("fotografia")
        }
        if (this.state.documentoCheck6) {
            documentos.push("forma_extranjero")
        }
        if (this.state.documentoCheck7) {
            documentos.push("contrato_estudiantil")
        }
        if (this.state.documentoCheck8) {
            documentos.push("nss")
        }

        Fetch('/updatePeriodo', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, convocatoria, documentos, etapa: nombre, fecha_inicio: inicio, fecha_final: termino, descripcion: descripcion })
        }).then(Response => {
            this.props.actualizarEtapa();
            this.props.cerrar();
        }).catch(err => {
            switch (err.status) {

                case 600:
                    toast.error('Error inesperado')
                    break;

                case 601:
                    toast.error('Esta convocatoria ya existe')
                    break;

                case 604:
                    toast.error('Esta convocatoria no pudo ser registrado')
                    break;

                default:
                    break;
            }
        })
    }

    documentRead(documentos) {
        for (var i = 0; i < documentos.length; i++){
            switch (documentos[i].toString()) {
                case "solicitud":
                    this.state.documentoCheck1 = true
                    break;
                case "acta_nacimiento":
                    this.state.documentoCheck2 = true
                    break;
                case "acta_curp":
                    this.state.documentoCheck3 = true
                    break;
                case "documento_institucional":
                    this.state.documentoCheck4 = true
                    break;
                case "fotografia":
                    this.state.documentoCheck5 = true
                    break;
                case "forma_extranjero":
                    this.state.documentoCheck6 = true
                    break;
                case "contrato_estudiantil":
                    this.state.documentoCheck7 = true
                    break;
                case "nss":
                    this.state.documentoCheck8 = true
                    break;
            }
        }
    }

    render() {
        if (this.state.documentos) this.documentRead(this.state.documentos);
        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data">

                        <FormGroup >
                            <Label> Nombre de la etapa</Label>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "nombre")} placeholder="Procure un nombre corto" name="number" defaultValue={this.state.nombre} />
                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Label> Fecha de Incio de la etapa</Label>
                            <Input className="w-100" type="date" onChange={this.setValue.bind(this, "inicio")} placeholder="" name="inicio" defaultValue={this.state.inicio} />
                            <FormFeedback>{this.state.errors.inicio}</FormFeedback>
                        </FormGroup>

                        <FormGroup >
                            <Label> Fecha de Término de la etapa</Label>
                            <Input className="w-100" type="date" onChange={this.setValue.bind(this, "termino")} placeholder="" name="termino" defaultValue={this.state.termino} />
                            <FormFeedback>{this.state.errors.termino}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Label> Descripción de la Convocatoria</Label>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "descripcion")} placeholder="Con la mayor brevedad posible" name="descripcion" defaultValue={this.state.descripcion} />
                            <FormFeedback>{this.state.errors.descripcion}</FormFeedback>
                        </FormGroup>

                        <Label>
                            Documentos a solicitar esta etapa
                        </Label>
                        <Col className="xs-8">
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Solicitud </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck1 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck1: !state.documentoCheck1 }))}>
                                        {this.state.documentoCheck1 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Acta de Nacimiento </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck2 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck2: !state.documentoCheck2 }))}>
                                        {this.state.documentoCheck2 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Acta de CURP </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck3 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck3: !state.documentoCheck3 }))}>
                                        {this.state.documentoCheck3 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Documento Institucional </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck4 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck4: !state.documentoCheck4 }))}>
                                        {this.state.documentoCheck4 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Fotografía </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck5 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck5: !state.documentoCheck5 }))}>
                                        {this.state.documentoCheck5 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Forma Extranjero </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck6 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck6: !state.documentoCheck6 }))}>
                                        {this.state.documentoCheck6 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> Contrato Estudiantil </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck7 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck7: !state.documentoCheck7 }))}>
                                        {this.state.documentoCheck7 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Row>
                                <Col xs="6" className="text-left"> NSS </Col>
                                <Col xs="6" className="text-right">
                                    <Button className={this.state.documentoCheck8 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck8: !state.documentoCheck8 }))}>
                                        {this.state.documentoCheck8 ? "Seleccionado" : "No Seleccionado"}
                                    </Button>
                                </Col>
                            </Row>
                            {this.state.documentTest}
                            <hr className="my-1" />
                        </Col>

                        <br />
                        <CardLink>
                            <Button color="info" onClick={() => this.guardar()}>Guardar</Button>
                            <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                        </CardLink>
                    </Form>
                </CardBody>
            </Card>
        )
    }
}
